export const toastMixin = {
  data() {
    return {
      toast: { show: false, message: '', type: 'success' },
      toastTimer: null
    };
  },
  methods: {
    showToast(message, type = 'success') {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toast = { show: true, message, type };
      const duration = type === 'error' ? 5000 : 2500;
      this.toastTimer = setTimeout(() => { this.toast.show = false; }, duration);
    }
  },
  beforeDestroy() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  }
};
